<template>
    <div id="eterminal-container">
        <v-row>
            <v-col lg="6" md="6" sm="12" xs="12" offset-lg="3" offset-md="3">

                <v-overlay :value="loading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                    <v-row >
                        <v-col md="6" class="pt-0">
                            <v-btn class="primary" @click="dialog = true; result = null; transactionId = null;">Create Payment</v-btn>
                        </v-col>
                    </v-row>

                    <!-- <svg id="svg" viewBox="0 0 100 65">
                        <text id="card-number" class="card-items" x="5" y="38" font-size="0.49em">{{ card.number }}</text>
                        <text id="card-holder" class="card-items" x="5" y="48" font-size="0.4em">{{ card.holder }}</text>
                        <text id="card-expiry" class="card-items" x="5" y="58" font-size="0.4em">{{ card.expiry }}</text>
                        <text id="card-cvv" class="card-items" x="82" y="58" font-size="0.4em">{{ card.cvv }}</text>
                    </svg> -->

                    <svg v-show="card.number.startsWith('4')" id="svg-visa" class="reg-form-svg" viewBox="0 0 100 65">
                        <text id="card-number" class="card-items" x="5" y="38" font-size="0.49em">{{ card.number }}</text>
                        <text id="card-holder" class="card-items" x="5" y="48" font-size="0.4em">{{ card.holder }}</text>
                        <text id="card-expiry" class="card-items" x="5" y="58" font-size="0.4em">{{ card.expiry }}</text>
                        <text id="card-cvv" class="card-items" x="84" y="48" font-size="0.4em">{{ card.cvv }}</text>
                    </svg>

                    <svg v-show="card.number.startsWith('5')" id="svg-mastercard" class="reg-form-svg" viewBox="0 0 100 65">
                        <text id="card-number" class="card-items" x="5" y="38" font-size="0.49em">{{ card.number }}</text>
                        <text id="card-holder" class="card-items" x="5" y="48" font-size="0.4em">{{ card.holder }}</text>
                        <text id="card-expiry" class="card-items" x="5" y="58" font-size="0.4em">{{ card.expiry }}</text>
                        <text id="card-cvv" class="card-items" x="84" y="48" font-size="0.4em">{{ card.cvv }}</text>
                    </svg>

                    <svg v-show="card.number.startsWith('3')" id="svg-amex" class="reg-form-svg" viewBox="0 0 100 65">
                        <text id="card-number" class="card-items" x="5" y="38" font-size="0.49em">{{ card.number }}</text>
                        <text id="card-holder" class="card-items" x="5" y="48" font-size="0.4em">{{ card.holder }}</text>
                        <text id="card-expiry" class="card-items" x="5" y="58" font-size="0.4em">{{ card.expiry }}</text>
                        <text id="card-cvv" class="card-items" x="80" y="48" font-size="0.4em">{{ card.cvv }}</text>
                    </svg>
                    
                    <svg v-show="!card.number || (!card.number.startsWith('4') && !card.number.startsWith('5') && !card.number.startsWith('3'))" id="svg-blank" class="reg-form-svg" viewBox="0 0 100 65">
                        <text id="card-number" class="card-items" x="5" y="38" font-size="0.49em">{{ card.number }}</text>
                        <text id="card-holder" class="card-items" x="5" y="48" font-size="0.4em">{{ card.holder }}</text>
                        <text id="card-expiry" class="card-items" x="5" y="58" font-size="0.4em">{{ card.expiry }}</text>
                        <text id="card-cvv" class="card-items" x="84" y="48" font-size="0.4em">{{ card.cvv }}</text>
                    </svg>

                    <v-row v-if="result && result.result.code == '000.000.000'">
                        <v-col md="12" class="py-0">
                            <v-alert
                                type="success"
                                text border="left"
                                dismissible
                                class="mb-2">
                                Code: {{ result.result.code }}<br>
                                Description: {{ result.result.description }}
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row v-else-if="result && result.result.code != '000.000.000'" class="px-4">
                        <v-col md="12" class="">
                            <v-alert type="error" text border="left" dismissible>
                                Code: {{ result.result.code }}<br>
                                Description: {{ result.result.description }}
                            </v-alert>
                        </v-col>
                    </v-row>

                    <v-card class="px-4 py-2 pb-0 elevation-0" color="#FAFAFA">
                        <iframe id="threeDsContainer" src="about:blank" frameBorder="0" scrolling="no"></iframe>
                    </v-card>
          
                    <v-dialog
                        v-model="dialog"
                        max-width="500"
                        persistent
                    >
                        <v-card color="rgba(255, 255, 255, 0.85)">
                            <v-card-title class="px-3">Payment Details</v-card-title>
                            <v-divider></v-divider>
                            <v-form ref="form" lazy-validation @submit="onSubmit">
                                <div class="px-4 py-2 pb-2">
                                    <v-row>
                                        <v-col md="12" class="pb-0 pt-2">
                                            <v-autocomplete
                                                v-model="card.channel"
                                                :items="channels"
                                                item-text="name"
                                                item-value="uuid"
                                                label="Channel"
                                                :rules="[rules.required]"
                                                @change="currencyHandle"
                                            ></v-autocomplete>
                                        </v-col>
                                    </v-row>

                                    <v-row v-if="threeDv2Check && $store.state.user.user_role.id <= 3">
                                        <v-col md="12" class="py-0">
                                            <v-select
                                                v-model="card.threeDv2"
                                                :items="threeDv2Options"
                                                label="3D Secure v2.0"
                                            ></v-select>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col md="12" class="py-0">
                                            <v-text-field
                                                v-model="card.merchantTransactionId"
                                                label="Reference"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col md="12" class="py-0">
                                            <v-text-field
                                                v-model="card.number"
                                                label="Card Number"
                                                v-mask="masks.number"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col md="12" class="py-0">
                                            <v-text-field
                                                v-model="card.holder"
                                                label="Card Holder"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col md="4" class="py-0">
                                            <v-text-field
                                                v-model="card.amount"
                                                label="Amount"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col md="4" class="py-0">
                                            <v-select
                                                v-model="card.currency"
                                                :items="currencies"
                                                :rules="[rules.required]"
                                                label="Currency"
                                            ></v-select>
                                        </v-col>
                                        <v-col md="4" class="py-0">
                                            <v-select
                                                v-model="card.recurring"
                                                :items="recurring"
                                                label="Recurring Type"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
            
                                    <v-row class="">
                                        <v-col md="4" class="py-0">
                                            <v-text-field
                                                v-model="card.expiry"
                                                label="Expiry"
                                                v-mask="masks.expiry"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col md="4" class="py-0">
                                            <v-text-field
                                                v-if="card.number.startsWith('3')"
                                                v-model="card.cvv"
                                                label="CVV"
                                                v-mask="masks.amexCvv"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                            <v-text-field
                                                v-else
                                                v-model="card.cvv"
                                                label="CVV"
                                                v-mask="masks.cvv"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col md="4" class="py-0">
                                            <v-text-field
                                                v-model="card.postcode"
                                                label="Postcode"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </div>
                                
                                <v-divider></v-divider>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="error" @click="dialog = false">Cancel</v-btn>
                                    <v-btn color="primary" type="submit">Pay Now</v-btn>
                                </v-card-actions>
                            </v-form>
                            
                        </v-card>
                    </v-dialog>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';

export default {
    directives: { mask },
    data() {
        return {
            dialog: false,
            card: {
                channel: null,
                merchantTransactionId: null,
                number: '',
                holder: '',
                amount: null,
                currency: null,
                recurring: null,
                expiry: '',
                cvv: '',
                postcode: null,
                threeDv2: 0,
                agent: navigator.userAgent
            },
            currencies: [],
            recurring: [{ value: null, text: 'NONE' },
                         { value: 'INITIAL', text: 'INITIAL' },
                         { value: 'REPEATED', text: 'REPEATED' }],
            threeDv2Options: [{ value: 0, text: 'No'},
                              { value: 1, text: 'Yes'}],
            masks: {
                number: '#### #### #### ####',
                expiry: '##/##',
                cvv: '###',
                amexCvv: '####'
            },
            rules: {
                required: v => !!v || 'Required.',
            },
            channels: [],
            transactionId: null,
            result: null,
            loading: false
        }
    },
    computed: {
        uri() {
            return this.$store.state.sysState ? 'live' : 'test';
        },
        threeDv2Check() {
            if(this.card.channel) {
                let channel = this.channels.find(e => e.uuid == this.card.channel);
                return channel.name.toLowerCase().includes('3d') ? true : false;
            }
            else {
                return false;
            }
        }
    },
    beforeMount() {
        this.getChannels();
    },
    methods: {
        getChannels() {
            if(this.$store.state.user.user_role.id <= 3) {
                axios({
                method: 'get',
                url: `get-channels-live`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    response.data.map(e => {
                        let currencies = e.currencies.split(',');
                        this.channels.push({ uuid: e.channelUuid,
                                             name: `${e.merchantName} - ${e.channelName}`,
                                             currencies: currencies });
                    })
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else if(this.$store.state.user.user_role.id > 3) {
                axios({
                method: 'post',
                url: `get-channels-live-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    response.data.map(e => {
                        let currencies = e.currencies.split(',');
                        this.channels.push({ uuid: e.channelUuid,
                                             name: `${e.merchantName} - ${e.channelName}`,
                                             currencies: currencies });
                    })
                    this.channels.sort(this.compare);
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        onSubmit(e) {
            e.preventDefault();
            if(this.$refs.form.validate()) {
                this.dialog = false;
                
                axios({
                method: 'post',
                url: `server-to-server-payment-live`,
                data: { card: this.card },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.transactionId = response.data.id;

                    if(response.data.result.code == '000.200.000') {
                        this.loading = true;
                        let iFrame = document.getElementById('threeDsContainer');
                        iFrame = iFrame.contentWindow || iFrame.contentDocument.document || iFrame.contentDocument;
                        iFrame.document.open();

                        let iframeData = '';
                        response.data.redirect.parameters.map(e => {
                            
                            iframeData += `<input type="text" name='${e.name}' value='${e.value}' />`;
                        });

                        const iframeForm = `<style type='text/css'>body { visibility: hidden; }</style><form method='post' action='${response.data.redirect.url}' id='3ds-form'>${iframeData}<input type="submit" id="submitForm"/></form>`;
                        iFrame.document.write(iframeForm);
                        iFrame.document.close();

                        iFrame = iFrame.document;
                        setTimeout(() => { 
                            iFrame.getElementById('3ds-form').submit(); 
                            setTimeout(() => { this.getTransaction(); }, 15000);
                        }, 2000);
                    
                    }
                    else {
                        this.loading = true;
                        this.result = response.data;
                        this.loading = false;
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getTransaction() {
            axios({
            method: 'post',
            url: `get-transaction-live`,
            data: { uuid: this.transactionId, channel: this.card.channel },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.result = response.data;
                this.loading = false;

                this.card = { channel: null,
                              number: '',
                              holder: '',
                              amount: null,
                              currency: null,
                              recurring: null,
                              expiry: '',
                              cvv: '',
                              postcode: null }
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        compare(a, b) {
            const x = a.name.toUpperCase();
            const y = b.name.toUpperCase();

            let comparison = 0;
            if (x > y) {
                comparison = 1;
            } else if (x < y) {
                comparison = -1;
            }
            return comparison;
        },
        currencyHandle(a) {
            this.channels.find(e => { 
                if(e.uuid == a) {
                    this.currencies = e.currencies;
                }
            });
        }
    }
}
</script>

<style scoped>
    #eterminal-container {
        margin-left: -55px;
    }

    .card-items {
        font-family: 'Courier New', Courier, monospace;
        font-weight: 600;
        fill: #fff;
    }

    #svg {
        background: url('../../assets/tp-card-3.png') no-repeat #FAFAFA;
        background-size: 100%;
    }

    #svg-visa {
        background: url('../../assets/tp-card-blank-visa.png') no-repeat;
        background-size: 100%;
    }

    #svg-mastercard {
        background: url('../../assets/tp-card-blank-mastercard.png') no-repeat;
        background-size: 100%;
    }
    
    #svg-amex {
        background: url('../../assets/tp-card-blank-amex.png') no-repeat;
        background-size: 100%;
    }
    
    #svg-blank {
        background: url('../../assets/tp-card-blank.png') no-repeat;
        background-size: 100%;
    }

    #threeDsContainer {
        display: block;
        background: #FAFAFA;
        border: none;
        height: 100vh;
        width: 100%;
    }

    #threeDsContainer body {
        color: #FAFAFA;
        font-size: 0px;
    }

</style>